<template>
  <vx-card no-shadow>
    <div class="mb-base">
      <vs-input class="w-full" type="password" label-placeholder="รหัสผ่านปัจจุบัน" v-model="password.old_password" data-vv-validate-on="blur" v-validate="'required'" name="old_password" data-vv-as="รหัสผ่านปัจจุบัน" />
      <span class="text-danger text-sm">{{ errors.first('old_password') }}</span>
    </div>
    <div class="mb-base">
      <vs-input ref="new_password" class="w-full" type="password" label-placeholder="รหัสผ่านใหม่" v-model="password.new_password" data-vv-validate-on="blur" v-validate="'required|min:6|max:20'" name="new_password" data-vv-as="รหัสผ่านใหม่" />
      <span class="text-danger text-sm">{{ errors.first('new_password') }}</span>
    </div>
    <div class="mb-base">
      <vs-input class="w-full" type="password" label-placeholder="ยืนยันรหัสผ่าน" v-model="password.confirm_password" data-vv-validate-on="blur" v-validate="'min:6|max:20|confirmed:new_password'" name="confirm_password" data-vv-as="ยืนยันรหัสผ่าน" />
      <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>
    </div>
    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" :disabled="!validateForm" @click="changePassword()">เปลี่ยนรหัสผ่าน</vs-button>
    </div>
  </vx-card>
</template>
<script>
import auth from "@/services/authService"
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  data() {
    return {
      password: {
        old_password: '',
        new_password: '',
        confirm_password: ''
      }
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.password.old_password != '' && this.password.new_password != '' && this.password.confirm_password != '';
    }
  },
  methods: {
    changePassword() {

      if (!this.validateForm) return false;

      /*auth.changePassword(this.password).then((response) => {

        if (response.result === 'success') {

          this.$vs.notify({
            title: 'สำเร็จ!',
            text: 'เปลี่ยนรหัสผ่านเสร็จเรียบร้อย...กรุณาเข้าสู่ระบบอีกครั้ง',
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });

          var self = this;
          setTimeout(function() {
            self.$store.dispatch('reloadProfile');
          }, 2000);

        } else
        if (response.result === 'invalid') {

          this.$vs.notify({
            title: 'ผิดพลาด!',
            text: 'รหัสผ่านปัจจุบันไม่ถูกต้อง',
            iconPack: 'feather',
            icon: 'icon-x-circle',
            color: 'danger'
          });

        } else {

          this.$vs.notify({
            title: 'ผิดพลาด!',
            text: 'เปลี่ยนรหัสผ่านไม่สำเร็จ',
            iconPack: 'feather',
            icon: 'icon-x-circle',
            color: 'danger'
          });

        }
      });*/

      let user = firebase.auth().currentUser;
      console.log('user', user)
      let self = this

      firebase
      .auth()
      .signInWithEmailAndPassword(user.email, this.password.old_password)
      .then(async () => {

        firebase.auth().currentUser.updatePassword(this.password.new_password).then(function() {
          // Update successful.
          self.$vs.notify({
            title: 'สำเร็จ!',
            text: 'เปลี่ยนรหัสผ่านเสร็จเรียบร้อย...กรุณาเข้าสู่ระบบอีกครั้ง',
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });

          setTimeout(() => {
            auth.logout()
          }, 2000);
        }).catch((err) => {
          // An error happened.
          console.log(err)
          self.$vs.notify({
            title: 'ผิดพลาด!',
            text: 'เปลี่ยนรหัสผ่านไม่สำเร็จ',
            iconPack: 'feather',
            icon: 'icon-x-circle',
            color: 'danger'
          });
        });

      })
      .catch(() => {
        self.$vs.notify({
          title: 'ผิดพลาด!',
          text: 'รหัสผ่านปัจจุบันไม่ถูกต้อง',
          iconPack: 'feather',
          icon: 'icon-x-circle',
          color: 'danger'
        });
      })

    }
  }
}

</script>
<style>
.input-span-placeholder {
  font-size: 0.9rem !important;
}

</style>
